import React from 'react';
import { styled } from '@mui/material/styles';
import AccountMenu from './AccountMenu';

// Blends with the page (same background.default), separated by a soft shadow that disappears into the dark rail — badge and rail meet seamlessly.
const Header = styled('header')(({ theme }) => ({
  height: 56,
  flexShrink: 0,
  display: 'flex',
  alignItems: 'stretch',
  background: theme.palette.background.default,
  color: 'rgba(0,0,0,0.87)',
  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  position: 'relative',
  zIndex: 40,
}));

const Spacer = styled('div')({ flex: 1 });

// Right padding matches the 24px content gutter so the avatar lines up with the actions below.
const RightGroup = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 14,
  padding: '0 24px 0 16px',
});

// No title (the rail marks the destination); the brand shield lives atop the rail so a hoisted sub-nav can reach the viewport top.
/** Fixed 48px top header: account menu only. */
export default function HeaderBar() {
  return (
    <Header>
      <Spacer />

      <RightGroup>
        <AccountMenu />
      </RightGroup>
    </Header>
  );
}
